import { getLocale } from "../runtime";

const sv_priceascending = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Pris stigande`
};

const priceascending = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_priceascending(inputs)
	return "priceAscending";
};

export { priceascending as "priceAscending" };